module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/9ddae4f6c1aeaf0784007203d9d4ac9c.svg";